export default __webpack_public_path__ + "static/media/dashboard_max.c9f0adf9.svg";